import * as React from 'react';
import * as _ from 'lodash';
import queryString from 'query-string';
import {useRoute} from 'react-router5';
import FieldContext from './FieldContext';
import {useGroupContext} from '../Group';
import {FieldObject, FieldProps} from './types';

/**
 * The field of the filter.
 * @param {FieldProps} props
 * @return {React.ReactElement<FieldProps>}
 * @constructor
 */
export default function Field(
    props: FieldProps,
): React.ReactElement<FieldProps> {
  const {route, router} = useRoute();
  const {name} = useGroupContext();

  /**
   * Is the field checked.
   * @return {boolean}
   */
  function isChecked(): boolean {
    const param = route?.params[name];

    switch (props.type) {
      case 'checkbox': {
        if (typeof param === 'string') {
          return param === props.value;
        } else {
          return param?.find((value: string) => (
            value === props.value
          ));
        }
      }
      case 'radio': return (
        param === props.value
      );
    }
  }

  const field: FieldObject = {
    type: props.type,
    value: props.value,
    label: props.label,
    checked: isChecked(),
    onChange: handleChange,
  };

  /**
   * The change event handler.
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */
  function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
    switch (field.type) {
      case 'checkbox': {
        router.navigate(route.name, {
          ...route.params,
          [name]: event.target.checked ? route?.params[name] ? (
            typeof route.params[name] === 'string' ? ([
              route.params[name],
              event.target.value,
            ]) : ([
              ...route.params[name],
              event.target.value,
            ])
          ) : event.target.value : (
            route?.params[name] ? undefined : undefined
          ),
        });
        break;
      }
      case 'radio': {
        router.navigate(route.name, {
          ...route.params,
          [name]: event.target.value,
        });
        break;
      }
    }
  }

  return (
    <FieldContext.Provider value={field}>
      {props.children(field)}
    </FieldContext.Provider>
  );
}
